/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TGenericModelNode } from "@adapptio/lib-blueprint";

/**
 * Returns if a blueprint model schema matches the given one
 *
 * @param model Node model
 * @param schemaName Schema name
 */
export function isModelSchemaOf(model: TGenericModelNode, schemaName: string | string[]): boolean {
	if (Array.isArray(schemaName)) {
		return schemaName.includes(model?.schema.name);
	} else {
		return model?.schema.name === schemaName;
	}
}
